import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio, Switch } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import MerchantPicker from "src/components/common/MerchantPicker";
import UserPicker from "src/components/common/UserPicker";
import Confirm from "src/components/common/ConfirmDialog";
import { useSelector } from "react-redux";

const PaymentAddDialog = ({ open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    amount: "",
    password: "",
    remark: "",
    enableSxy: true,
    enableMarket: true,
    enableQgyy: true,
  });

  const [merchant, setMerchant] = useState({});
  const [user, setUser] = useState({});
  const [toUser, setToUser] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert("数量不能为空");
    if (!user.uid) return alert("请选择用户");
    if (!merchant.mid) return alert("请选择商户");

    Confirm({
      message: `确定用户${user.uid}给商户 “${merchant.name}” 支付${form.amount}元吗？`,
      async onConfirm() {
        setSubmitting(true);

        const { msg } = await asyncRequest({
          path: "/payment/add",
          data: {
            ...form,
            uid: user.uid,
            mid: merchant.mid,
            toUid: toUser.uid,
          },
          complete() {
            setSubmitting(false);
          },
        });

        alert(msg, "success");
        onUpdate();
      },
    });
  }

  function handleSelectMerchant() {
    MerchantPicker({
      onSelect(val) {
        console.log(val);
        setMerchant(val);
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setUser(val);
      },
    });
  }

  function handleSelectToUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setToUser(val);
      },
    });
  }

  return (
    <FormDialog title="添加支付订单" open={open} onClose={onClose} submitting={submitting} onConfirm={handleConfirm}>
      <FormItem title="商户" required sx={{ width: 500 }}>
        <TextField fullWidth placeholder="请选择商户" autoComplete="off" id="merchant" value={merchant.name || ""} size="small" onClick={() => handleSelectMerchant()} />
      </FormItem>

      {!!merchant.mid && (
        <FormItem title="商户让利" sx={{ width: 500 }}>
          <TextField fullWidth disabled autoComplete="off" id="merchant" value={merchant.rangli + "%"} size="small" />
        </FormItem>
      )}

      {/* {!!merchant.mid && (
        <FormItem title="商户版本" sx={{ width: 500 }}>
          <TextField fullWidth disabled autoComplete="off" id="merchant" value={merchant.version + ".0"} size="small" />
        </FormItem>
      )} */}

      <FormItem title="付款人" required>
        <Stack onClick={handleSelectUser}>
          <UserInfo {...user} enablePreview={false} />
        </Stack>
        {/* <TextField fullWidth placeholder="请选择用户" autoComplete="off" id="user" value={user.uid} size="small" onClick={() => handleSelectUser()} /> */}
      </FormItem>

      <FormItem title="支付数额" required>
        <TextField fullWidth type="number" placeholder="支付数额" autoComplete="off" id="amount" value={form.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      {!!merchant.mid && !!form.amount && (
        <FormItem title="获得积分">
          <TextField fullWidth type="number" placeholder="获得积分" disabled id="amount" value={(form.amount * merchant.rangli) / 100} size="small" />
        </FormItem>
      )}

      <FormItem title="被代付人" required>
        <Stack onClick={handleSelectToUser}>
          <UserInfo {...toUser} enablePreview={false} />
        </Stack>
        {/* <TextField fullWidth placeholder="请选择用户" autoComplete="off" id="user" value={user.uid} size="small" onClick={() => handleSelectUser()} /> */}
      </FormItem>

      <FormItem title="密码" required>
        <TextField fullWidth placeholder="密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth placeholder="备注" autoComplete="off" id="remark" value={form.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default PaymentAddDialog;
